import * as store from '@/store';
import sdk from '@/sdk';
import {ServerConfig} from '@/config/routers';

import type {IUser} from '../types';

export const user: IUser = {
    getUserInfo: () => {
        const userInfo = store.getData(store.KEYS.USER) || {};
        const {avatar, nickname, email, department, userGuid} = userInfo;

        return {
            name: avatar,
            nickname,
            email,
            department,
            avatar: `${ServerConfig.ku}/users/avatar?userGuid=${userGuid}`,
        };
    },
    getCreatorInfo: async () => {
        try {
            const userGuid = store.getData(store.KEYS.CUR_DOCUMENT)?.userGuid || '';
            let creatorInfo = store.getUserInfo(userGuid);

            if (!creatorInfo) {
                const result = await sdk.as.getUserInfoList([userGuid]);
                creatorInfo = result?.[0] || {};
            }

            const {avatar, nickname, email, department, avatarUrl} = creatorInfo || {};
            return {
                name: avatar || '',
                nickname: nickname || '',
                email: email || '',
                department: department || '',
                avatar: avatarUrl || '',
            };
        } catch {
            return {};
        }
    },
};
